/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./Surveys.module.css";
import { useEffect, useState, useRef } from "react";
import Footer from "../../components/Footer";
import DarkLogo from "../../assets/dark-logo.png";
import surveysService from "../../services/surveys";
import { ISurveysResponse, ISurveyItem } from "../../libs/interfaces/services";
import { useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { useContextSurveyQuiz } from "../../hooks/useSurveyQuiz";
import ProgressBar from "../../components/ProgressBar";
import { orderByList } from "../../helpers/orderByList";
import { isValidAnswer } from "../../helpers/isValidAnswer";
import { BsQuestionOctagonFill } from "react-icons/bs";

interface IHelpText {
  description: string | undefined;
}
interface ILoading {
  isLoading: boolean;
  id: string | number;
}

interface ITopicArr {
  idTopic: string | number;
  count: number;
}

function InformationBox({ surveys }: any) {
  return (
    <div className={styles.informationBox}>
      {surveys?.surveyList ? (
        <div style={{ maxWidth: "1140px" }}>
          <h1>{surveys?.title}</h1>
          <h2>{surveys?.subtitle}</h2>
          <h3>{surveys?.description}</h3>
        </div>
      ) : (
        <div style={{ maxWidth: "1140px" }}>
          <h1>{surveys?.finalMessage?.title}</h1>
          <h2>{surveys?.finalMessage?.subtitle}</h2>
          <h3>{surveys?.finalMessage?.description}</h3>
        </div>
      )}
    </div>
  );
}

function SurveysContainer({ surveys }: any) {
  const { hashID } = useParams();
  const { setNumberTopics, handleGetAnsweredList } = useContextSurveyQuiz();
  const [loading, setLoading] = useState<ILoading>({
    isLoading: false,
    id: 0,
  });
  const isProcessingRef = useRef(false);

  const surveyListOrganized = surveys?.object?.surveyList?.sort(orderByList);

  const orderByIdTopic = (arr: ITopicArr[]) => {
    const orderedArr = arr.sort((a, b) => {
      if (a.idTopic < b.idTopic) {
        return -1;
      }
      if (a.idTopic > b.idTopic) {
        return 1;
      }
      return 0;
    });

    return orderedArr;
  };

  const handleNavigateSurvey = async (idSurvey: string | number) => {
    // Previne múltiplos cliques - se já estiver processando, ignora o clique
    if (isProcessingRef.current || loading.isLoading) {
      return;
    }

    // Marca como processando
    isProcessingRef.current = true;
    setLoading({
      isLoading: true,
      id: idSurvey,
    });

    try {
      const listSurv = await surveysService.listSurveyQuestions(
        String(idSurvey),
        hashID ? hashID : ""
      );

      const object = listSurv.object.topics.sort((a, b) => {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      });

      const listAswered = await handleGetAnsweredList(String(idSurvey), hashID);
      const topics = object?.map((topic) => ({ idTopic: Number(topic.idTopic) }));

      // Função para verificar se um tópico está completamente respondido
      // Um tópico está completo quando TODAS as questões obrigatórias têm TODAS as subquestões obrigatórias respondidas
      const isTopicFullyAnswered = (topic: any, answers: any[]) => {
        if (!topic.questions || topic.questions.length === 0) {
          return true; // Se não tem questões, considera respondido
        }

        // Filtra respostas válidas deste tópico
        const topicAnswers = answers.filter(
          (answer) => answer.idTopic === Number(topic.idTopic) && isValidAnswer(answer)
        );

        // Percorre todas as questões do tópico
        for (const question of topic.questions) {
          if (!question.groupsQuestionItens || question.groupsQuestionItens.length === 0) {
            continue;
          }

          // Verifica TODAS as subquestões obrigatórias desta questão
          for (const subQuestion of question.groupsQuestionItens) {
            if (subQuestion.required) {
              // Procura uma resposta válida para esta subquestão obrigatória
              const answer = topicAnswers.find(
                (ans) => ans.idSubQuestion === subQuestion.idSubQuestion
              );

              // Se não encontrou resposta válida, o tópico não está completo
              if (!answer || !isValidAnswer(answer)) {
                return false;
              }
            }
          }
        }

        return true;
      };

      setNumberTopics(topics);

      // Encontra o primeiro tópico com questões obrigatórias não respondidas
      let topicToNavigate = null;

      for (const topic of object) {
        const topicAnswers = listAswered.filter(
          (answer) => answer.idTopic === Number(topic.idTopic)
        );

        // Verifica se o tópico está completamente respondido
        if (!isTopicFullyAnswered(topic, listAswered)) {
          topicToNavigate = topic.idTopic;
          break;
        }
      }

      // Se todos os tópicos estão respondidos, vai para o primeiro
      if (!topicToNavigate && object.length > 0) {
        topicToNavigate = object[0].idTopic;
      }

      // Navega para o tópico encontrado
      if (topicToNavigate) {
        window.location.href = `/${hashID}/survey-topic/${idSurvey}/${topicToNavigate}`;
      }

      // for (const obj of object) {
      //   const idTopic = obj?.idTopic;
      //   const answered = listAswered?.filter(
      //     (answer: any) => answer?.idTopic === idTopic
      //   ).length;

      //   if (obj?.questions?.length > answered) {
      //     window.location.href = `/${hashID}/survey-topic/${idSurvey}/${idTopic}`;
      //     break;
      //   } else {
      //     window.location.href = `/${hashID}/survey-topic/${idSurvey}/${idTopic}`;
      //     break;
      //   }
      // }
    } catch (error) {
      console.error("Erro ao navegar para o survey:", error);
    } finally {
      // Reseta o estado de processamento sempre, mesmo em caso de erro
      isProcessingRef.current = false;
      setLoading({
        isLoading: false,
        id: idSurvey,
      });
    }
  };

  return (
    <section className={styles.surveysContainer}>
      {!!surveyListOrganized &&
        surveyListOrganized?.map((survey: ISurveyItem) => {
          return (
            <button
              disabled={loading.isLoading}
              key={survey.idSurvey}
              onClick={() => handleNavigateSurvey(survey.idSurvey)}
              className={styles.surveyBox}
              style={loading.isLoading ? { cursor: "default", pointerEvents: "none" } : {}}
            >
              {loading.isLoading && loading.id === survey.idSurvey ? (
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    gap: "12px",
                  }}
                >
                  <div className={styles.cardSpinner} />
                  <p style={{ color: "#fff", fontSize: "13px", margin: 0, opacity: 0.8 }}>
                    Abrindo questionário...
                  </p>
                </div>
              ) : (
                <>
                  <div className={styles.surveyBoxStatus}>
                    <div style={{ background: survey.surveyStatus.color }} />
                    <p>{survey.surveyStatus.description}</p>
                  </div>

                  <h3>{survey.title}</h3>
                  <h4>{survey.subtitle}</h4>

                  <div className={styles.surveyBoxProgress}>
                    <ProgressBar
                      description="Progresso"
                      type="dark"
                      percentage={survey?.percentAnswered}
                    />
                  </div>
                </>
              )}
            </button>
          );
        })}
    </section>
  );
}

function HelpText({ description }: IHelpText) {
  return (
    <div className={styles.helpText}>
      <h4>{description}</h4>
    </div>
  );
}

function SurveyNotFound() {
  return (
    <div className={styles.notFoundContainer}>
      <h2 className={styles.notFoundTitle}>Pesquisa não encontrada</h2>
      <p className={styles.notFoundText}>
        O link que você acessou não está ativo ou não foi encontrado.
      </p>
      <p className={styles.notFoundHint}>
        Verifique se a pesquisa já foi finalizada ou se o endereço está correto.
      </p>
    </div>
  );
}

function Surveys() {
  const [loading, setLoading] = useState(true);
  const [surveys, setSurveys] = useState<ISurveysResponse>();
  const [hasError, setHasError] = useState(false);

  const { hashID } = useParams();

  useEffect(() => {
    async function loadSurveys() {
      try {
        const response = await surveysService.listSurveys(hashID ? hashID : "");

        if (!response?.success || !response?.object) {
          setHasError(true);
        } else {
          setSurveys(response);
        }
      } catch (error) {
        console.error("Erro ao carregar pesquisas:", error);
        setHasError(true);
      } finally {
        setLoading(false);
      }
    }

    loadSurveys();
  }, []);

  return (
    <>
      <section className={styles.surveys}>
        {loading ? (
          <Loading message="Carregando questionários" subtitle="Preparando seus formulários" />
        ) : hasError ? (
          <SurveyNotFound />
        ) : (
          <>
            <img src={DarkLogo} alt="dark logo" />
            <InformationBox surveys={surveys?.object} />
            <SurveysContainer surveys={surveys} />
            <HelpText description={surveys?.object?.descriptionFooter} />
          </>
        )}
      </section>
    </>
  );
}

export default Surveys;
